/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum org_coursera_payment_transaction_PaymentTransactionActionType {
  CHARGEBACK = "CHARGEBACK",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PAYMENT = "PAYMENT",
  QUERY = "QUERY",
  REFUND = "REFUND",
  VOID = "VOID",
}

export enum org_coursera_product_BillingCycle {
  ANNUAL = "ANNUAL",
  BIANNUAL = "BIANNUAL",
  MONTHLY = "MONTHLY",
}

export enum org_coursera_userverification_UserVerificationRequirementState {
  NEEDS_TO_ATTEST_NAME = "NEEDS_TO_ATTEST_NAME",
  NEEDS_TO_VERIFY_ID = "NEEDS_TO_VERIFY_ID",
  REQUIREMENT_MET = "REQUIREMENT_MET",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
